import {tv} from 'tailwind-variants'

export const hgComposableDetailsSection = tv({
  slots: {
    title: 'arcadia-subheading-5',
    body: 'flex flex-col gap-y-s6',
  },
  variants: {
    fullWidth: {
      true: {title: 'lg:col-span-6', body: 'lg:col-span-6'},
      false: {title: 'lg:col-span-4', body: 'lg:col-span-8'},
    },
  },
  defaultVariants: {
    fullWidth: false,
  },
})
